// @flow

export default (session: Object) => {};
